import { BookingClasses, BookingClassesWrapper } from "../types/booking.type";
import { ClassInstance } from "../types/class.type";
import { RenderEvents } from "../types/events.type";
import { ExerciseTask } from "../types/exercise.type";
import { RenderItem, RenderItemType, SetTimingsType } from "../types/render.types";
import { DateTimeUtils } from "../utils/datetime.utils";
import eventsService from "./events.service";

export class RenderEventService {
    // Emit the next workout event
    static emitExerciseNextWorkoutEvent(classSchedule: ClassInstance) {
        const classNextWorkout: RenderItem = {
            renderItemType: RenderItemType.EXERCISE_NEXT_WORKOUT,
            classSchedule,
            date: classSchedule.date,
            time: classSchedule.start_time,
            duration: DateTimeUtils.calculateSecondsToTime(classSchedule.start_time),
        };
        eventsService.emit(RenderEvents.classNextWorkout, classNextWorkout);
    }

    // Emit the next workout event
    static emitTimerNextWorkoutEvent(classSchedule: ClassInstance, task: ExerciseTask, timings: SetTimingsType) {
        if (!classSchedule || !task) {
            return;
        }

        const renderItemInfo = {
            exerciseTask: task,
            duration: task.time,
        };

        const renderData: RenderItem = {
            renderItemType: RenderItemType.TIMER_PRE_WORKOUT,
            renderItemInfo: renderItemInfo,
            classSchedule: classSchedule,
            date: classSchedule.date,
            time: classSchedule.start_time,
            duration: task.time,
            rest_time: timings.rest_time,
            work_time: timings.work_time
        };

        eventsService.emit(RenderEvents.timerPreWorkout, renderData);
    }

    static emitBookingDataEvent(booking: BookingClasses | undefined) {
        if (!booking) {
            return;
        }

        let bookingClassesWrapper: BookingClassesWrapper = {
            bookingClasses: booking
        };

        let renderItemInfo = {
            bookingClassesWrapper: bookingClassesWrapper
        };

        const renderItem: RenderItem = {
            renderItemType: RenderItemType.BOOKING,
            renderItemInfo: renderItemInfo,
        };

        eventsService.emit(RenderEvents.bookingClassesWrapper, renderItem);
    }

    // Emit movement data updated event
    static emitMovementEvent(classSchedule: ClassInstance) {
        const renderItem: RenderItem = {
            renderItemType: RenderItemType.MOVEMENT,
            classSchedule,
            date: classSchedule.date,
            time: classSchedule.start_time,
        };
        eventsService.emit(RenderEvents.movementDataUpdated, renderItem);
    }

    // Emit timer event
    static emitTimerEvent(classSchedule: ClassInstance, task: ExerciseTask) {
        if (!classSchedule || !task) {
            return;
        }

        const renderItemInfo = {
            exerciseTask: task,
            duration: task.time
        };

        const timerData: RenderItem = {
            renderItemType: RenderItemType.TIMER,
            renderItemInfo: renderItemInfo,
            classSchedule: classSchedule,
            date: classSchedule.date,
            time: classSchedule.start_time,
            duration: task.time,
        };
        eventsService.emit(RenderEvents.timerStartWorkout, timerData);
    }


    static emitExerciseTaskEvent = (classSchedule: ClassInstance, task: ExerciseTask) => {
        if (!classSchedule || !task) {
            return;
        }

        const renderItemInfo = {
            exerciseTask: task,
            duration: task.time
        };

        const renderItem: RenderItem = {  // Create a RenderItem object
            renderItemType: RenderItemType.EXERCISE,
            renderItemInfo: renderItemInfo,
            classSchedule: classSchedule,
            date: classSchedule.date,
            time: classSchedule.start_time,
            duration: task.time,
        };
        eventsService.emit(RenderEvents.classWorkoutStart, renderItem);
    }

}